// Avoid zooming on focus for inputs with a font-size smaller than 16px in iOS
if(navigator.userAgent.indexOf('iPhone') > -1) {
  document
    .querySelector('[name=viewport]')
    .setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
}
